export default "__VITE_ASSET__DmBpVJdG__"